import React from 'react';
import { Box, Container, Typography } from '@mui/material';

// Imágenes de cada servicio
import servicio1 from '../assets/servicio1.png';
import servicio2 from '../assets/servicio2.png';
import servicio3 from '../assets/servicio3.png';
import servicio4 from '../assets/servicio4.png';
import servicio5 from '../assets/servicio5.png';
import servicio6 from '../assets/servicio6.png';
import servicio7 from '../assets/servicio7.png';

const servicios = [
  {
    id: 1,
    nombreCorto: 'Video',
    titulo: 'VIDEO',
    imagen: servicio1,
    descripcion:
      'Producción de contenido audiovisual para redes sociales, televisión o plataformas digitales. Spots, reels, cápsulas informativas y materiales comerciales que eleven su marca.',
  },
  {
    id: 2,
    nombreCorto: 'CCTV',
    titulo: 'CCTV',
    imagen: servicio2,
    descripcion:
      'Montaje y operación de sistemas de video interno para auditorios, foros o eventos en vivo. Transmisión segura y estable en tiempo real para comunicación interna o monitoreo.',
  },
  {
    id: 3,
    nombreCorto: 'Streaming',
    titulo: 'STREAMING',
    imagen: servicio3,
    descripcion:
      'Producción y gestión de transmisiones en tiempo real con calidad HD o 4K. Ideal para eventos híbridos, capacitaciones y conferencias que buscan ampliar su alcance digital.',
  },
  {
    id: 4,
    nombreCorto: 'Pantallas LED',
    titulo: 'PANTALLAS LED',
    imagen: servicio4,
    descripcion:
      'Instalación y renta de pantallas LED de diferentes formatos y resoluciones. Perfectas para escenarios, congresos o eventos masivos que requieren gran visibilidad e impacto visual.',
  },
  {
    id: 5,
    nombreCorto: 'Audio',
    titulo: 'AUDIO',
    imagen: servicio5,
    descripcion:
      'Soluciones integrales de sonido para eventos, grabaciones y producciones. Montaje, microfonía, mezcla y monitoreo con calidad impecable.',
  },
  {
    id: 6,
    nombreCorto: 'Fotografía',
    titulo: 'FOTOGRAFÍA',
    imagen: servicio6,
    descripcion:
      'Capturamos tus momentos con calidad profesional.',
  },
  {
    id: 7,
    nombreCorto: 'Renta de equipos',
    titulo: 'RENTA DE EQUIPOS',
    imagen: servicio7,
    descripcion:
      'Disponemos de cámaras, iluminación, sonido, grúas y más. Equipos profesionales en renta con soporte técnico y opciones flexibles según las necesidades de su producción.',
  },
];

const Servicios = () => {
  return (
    <Box sx={{ backgroundColor: '#ffffff' }}>
      {/* HEADER NEGRO */}
      <Box
        sx={{
          backgroundColor: '#000000',
          color: '#ffffff',
          py: 6,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            sx={{
              fontFamily: 'Outfit, var(--title-font)',
              fontWeight: 700,
              fontSize: { xs: '2rem', md: '2.6rem' },
              textAlign: 'center',
              letterSpacing: 2,
            }}
          >
            SERVICIOS
          </Typography>
        </Container>
      </Box>

      {/* PSEUDO-NAV */}
      <Box
        sx={{
          backgroundColor: '#ffffff',
          borderBottom: '1px solid #d1d5db',
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              py: 2,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
              flexWrap: 'wrap',
            }}
          >
            {[
              'Video',
              'CCTV',
              'Streaming',
              'Pantallas LED',
              'Audio',
              'Fotografía',
              'Renta de equipos',
            ].map((item, index, arr) => (
              <Box
                key={item}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins, var(--text-font)',
                    fontSize: 14,
                    fontWeight: 400,
                    color: '#000000',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item}
                </Typography>

                {index < arr.length - 1 && (
                  <Box
                    sx={{
                      width: '1px',
                      height: 20,
                      backgroundColor: '#000000',
                    }}
                  />
                )}
              </Box>
            ))}
          </Box>
        </Container>
      </Box>

      {/* SECCIONES DETALLADAS */}
      {servicios.map((servicio) => {
        const isOdd = servicio.id % 2 === 1;
        const bgColor = isOdd ? '#edf0f2' : '#ffffff';

        return (
          <Box
            key={servicio.id}
            sx={{
              backgroundColor: bgColor,
              py: 8,
            }}
          >
            <Container maxWidth="lg">
              {/* TÍTULO CENTRADO */}
              <Box sx={{ mb: 4, textAlign: 'center' }}>
                <Typography
                  variant="h4"
                  sx={{
                    fontFamily: 'Outfit, var(--title-font)',
                    fontWeight: 700,
                    letterSpacing: 1,
                    textTransform: 'uppercase',
                    fontSize: { xs: '1.6rem', md: '1.8rem' }, // MÁS GRANDE
                    mb: 1,
                  }}
                >
                  {servicio.titulo}
                </Typography>

                {/* LÍNEAS CENTRADITAS */}
                <Box sx={{ mx: 'auto', width: 'fit-content' }}>
                  <Box
                    sx={{
                      width: 130,
                      height: 3,
                      backgroundColor: '#a9cf47',
                      mb: '1px',
                    }}
                  />
                  <Box
                    sx={{
                      width: 130,
                      height: 3,
                      backgroundColor: '#3c77b6',
                    }}
                  />
                </Box>
              </Box>

              {/* IMAGEN MÁS PEQUEÑA + CENTRADA */}
              <Box
                sx={{
                  borderRadius: 2,
                  overflow: 'hidden',
                  boxShadow: '0 16px 35px rgba(0,0,0,0.15)',
                  mb: 3,
                  mx: 'auto',
                  width: '100%',
                  maxWidth: 700, // límite de anchura
                  height: { xs: 200, md: 280 }, // MÁS PEQUEÑO
                }}
              >
                <img
                  src={servicio.imagen}
                  alt={servicio.titulo}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover', // mantiene estilo profesional
                    display: 'block',
                  }}
                />
              </Box>

              {/* DESCRIPCIÓN CENTRADA */}
              <Typography
                sx={{
                  fontFamily: 'Poppins, var(--text-font)',
                  fontSize: 15.5,
                  lineHeight: 1.7,
                  color: '#4b5563',
                  textAlign: 'center', // CENTRADO
                  maxWidth: 700,
                  mx: 'auto',
                }}
              >
                {servicio.descripcion}
              </Typography>
            </Container>
          </Box>
        );
      })}
    </Box>
  );
};

export default Servicios;
